import { configureStore } from '@reduxjs/toolkit'
import authSlice from './authSlice'
import scanSlice from './scanSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    scan: scanSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch